<template>
  <div id="contenedor-licitaciones-configuracion-firmas">
    Firmas
  </div>
</template>

<script>
export default {
  name: 'LicitacionesConfiguracionFirmas',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
